// How a run's records read on Watch live: each one's outcome, and the note that says why.

export const OUTCOME = {
  IN_PROGRESS: { label: "Working…", cls: "is-live" },
  ENROLLED: { label: "Enrolled", cls: "is-good" },
  PROCESSED: { label: "Done", cls: "is-good" },
  WOULD_ENROLL: { label: "Would enroll", cls: "is-good" },
  WOULD_PROCESS: { label: "Would process", cls: "is-good" },
  SKIPPED: { label: "Skipped", cls: "is-skip" },
  STOPPED: { label: "Stopped", cls: "is-skip" },
  AWAITING_APPROVAL: { label: "Awaiting approval", cls: "is-wait" },
  WAITING: { label: "Waiting", cls: "is-wait" },
  REJECTED: { label: "Not approved", cls: "is-skip" }
};

// What a record's steps found, in words: the trace keeps notes ("scored 54", "not enough signals to score") between
// the "✓ Step n" lines; the last note is the answer, the step lines are only the route.
const NOTE_WORDS = { "not enough signals to score": "Nothing recent in their hiring or posts to score" };
export const scoreOf = r => {
  const hit = (r.trace || []).map(t => /^scored (\d+)$/.exec(t)).find(Boolean);
  return hit ? Number(hit[1]) : null;
};
export const lastNote = r => {
  const note = (r.trace || []).filter(t => !/^[✓✕] Step /.test(t)).pop();
  return note ? NOTE_WORDS[note] || note.charAt(0).toUpperCase() + note.slice(1) : "";
};
/** A record the run handled, said as what it found: a score, or that there was nothing to score yet. */
export const outcomeOf = r => {
  if (r.disposition !== "PROCESSED") return OUTCOME[r.disposition] || { label: r.disposition, cls: "" };
  const score = scoreOf(r);
  if (score !== null) return { label: `Score ${score}`, cls: score >= 40 ? "is-good" : "" };
  if ((r.trace || []).includes("not enough signals to score")) return { label: "No signals yet", cls: "is-skip" };
  return OUTCOME.PROCESSED;
};
